import { atom } from "jotai";

/**
 * Controls whether canvas changes should be persisted to the backend.
 * When true, changes will not be saved.
 */
export const shouldBlockPersistenceAtom = atom<boolean>(false);
shouldBlockPersistenceAtom.debugLabel = "shouldBlockPersistenceAtom";
